/**
 * Auditoría (GEN-PX-016): lo que el kernel emite en el ítem `auditoria` del menú.
 * El kernel clasifica qué perfil ve qué (R-PT-02/R-PT-04); aquí solo se lee. Ocultar es cosmético.
 */
export const ID_AUDITORIA = 'auditoria'

/** Ítem `auditoria` del menú si es usable y trae al menos una entrada; si no, null. */
export function itemAuditoria(menu = []) {
  const m = menu.find(x => x && x.id === ID_AUDITORIA)
  const entradas = m ? (m.hijos ?? m.pestanas) : null  // `pestanas`: nombre anterior (kernel previo a GEN-PX-023), se retira con GEN-PX-021
  return m && m.visible && m.enabled && Array.isArray(entradas) && entradas.length > 0 ? m : null
}

/**
 * RESPALDO TEMPORAL (GEN-PX-016): el Pórtico se despliega al fusionar y el kernel espera al pipeline. Mientras el kernel
 * no emita `auditoria`, Detenciones sigue en Admin y la traza de Saber en la pantalla del KB. Se retira, junto con el
 * panel derecho, en GEN-PX-021; con el ítem presente, manda Auditoría.
 */
export const hayAuditoria = menu => itemAuditoria(menu) !== null
